import { render } from "./changepwd.vue?vue&type=template&id=6ead9f5e&scoped=true"
import script from "./changepwd.vue?vue&type=script&lang=js"
export * from "./changepwd.vue?vue&type=script&lang=js"

import "./changepwd.vue?vue&type=style&index=0&id=6ead9f5e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ead9f5e"]])

export default __exports__